import { useState, useCallback } from 'react';

export const useLocalStorageState = <StateType>(
  key: string,
  defaultValue: StateType,
): [StateType, (value: StateType) => void] => {
  const [state, setState] = useState<StateType>(() => {
    const valueInLocalStorage = window.localStorage.getItem(key);
    if (valueInLocalStorage) {
      return JSON.parse(valueInLocalStorage);
    }
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  });

  const setValue = useCallback(
    (value: StateType) => {
      try {
        const valueToStore = value instanceof Function ? value(state) : value;
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
        setState(valueToStore);
      } catch (err) {
        console.error(err);
      }
    },
    [state, key],
  );

  return [state, setValue];
};
